import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getNewsInner } from "../Service/Api";
const News = () => {
  const [data, setData] = useState([]); // State for gallery data
  const [loading, setLoading] = useState(true); // State for loading indicator

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const topperData = await getNewsInner();
        setData(topperData);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        // Handle error (e.g., show error message)
      } finally {
        setLoading(false); // Set loading to false after data fetching is complete
      }
    };
    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  return (
    <>
      <div className="newsbg">
        <div className="title">
          <h2>
            Notice Board{" "}
            <Link to="/News">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/arrow.png" />
            </Link>
          </h2>
        </div>
        <marquee
          onMouseOver={(event) => event.currentTarget.stop()}
          direction="up"
          onMouseOut={(event) => event.currentTarget.start()}
        >
          <ul className="newsboxlist">
            {data.length > 0 ? (
              data.map((item, index) => (
                <li key={index}>
                  <div className="newsbox">
                    <div className="newsdesc">
                      <h6>{item.title}</h6>
                      <p>{item.description}</p>
                    </div>
                    <p>
                      <i class="bi bi-calendar-event"></i>{" "}
                      {formatDate(item.fromDate)}{" "}
                      {item.attachments && item.attachments.length > 0 && (
                        <Link
                          to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                          target="_blank"
                        >
                          <i className="bi bi-paperclip"></i>
                        </Link>
                      )}
                    </p>
                  </div>
                </li>
              ))
            ) : (
              <li>
                <div className="newsbox">
                  <div className="newsdesc">
                    <h6>News Title</h6>
                  </div>
                  <p>
                    <i class="bi bi-calendar-event"></i> DD MM, YY{" "}
                    <Link to="#" target="_blank">
                      <i className="bi bi-paperclip"></i>
                    </Link>{" "}
                  </p>
                </div>
              </li>
            )}
          </ul>
        </marquee>
      </div>
    </>
  );
};

export default News;
